'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var modules_3fa78883 = {"container":"Breadcrumb_module_container__acd12244","item":"Breadcrumb_module_item__acd12244"};
require("../../../assets/cjs/components/Breadcrumb/src/Breadcrumb~C9Ijsmtn.css");

exports.default = modules_3fa78883;
//# sourceMappingURL=Breadcrumb.module.less.js.map
